// extracted by mini-css-extract-plugin
export default {"placeholder":"styles_placeholder__feZrN","activePlaceholder":"styles_activePlaceholder__EnU9L","checkbox":"styles_checkbox__P1zlq","modal__dialog":"styles_modal__dialog__M+fV+"};